import React from "react";
import "./Slot.css";

const Slot = (props) => {
  return (
    <div
      className={
        props.slotIsActive ? "slot-outer slot-outer-active" : "slot-outer"
      }
    >
      <div
        className={
          props.slotIsActive ? "slot-inner slot-inner-active" : "slot-inner"
        }
      ></div>
    </div>
  );
};

export default Slot;
